module.exports = __webpack_public_path__ + "img/2026-05-03c_3.5d69a80b.jpg";